import apiClient from './client'
import type {
    AvailabilityGrid,
    Booking,
    BookingSettings,
    CreateBookingRequest,
    CreateUserBookingRequest,
    CheckAvailabilityResponse,
    UpdateBookingRequest,
} from '../types/booking.types'
import type { TableType } from '../types/table.types'

export const fetchAvailabilityGrid = async (params: {
    startDate?: string
    tableType?: TableType | null
}): Promise<AvailabilityGrid> => {
    const query = new URLSearchParams()
    if (params.startDate) query.append('startDate', params.startDate)
    if (params.tableType) query.append('tableType', params.tableType)
    const response = await apiClient.get(`/bookings/availability-grid?${query.toString()}`)
    return response.data.data
}

export const fetchBookings = async (params: {
    from?: string
    to?: string
    status?: string
}): Promise<Booking[]> => {
    const query = new URLSearchParams()
    if (params.from) query.append('from', params.from)
    if (params.to) query.append('to', params.to)
    if (params.status) query.append('status', params.status)
    const response = await apiClient.get(`/bookings?${query.toString()}`)
    return response.data.data
}

export const createBooking = async (booking: CreateBookingRequest): Promise<Booking> => {
    const response = await apiClient.post('/bookings', booking)
    return response.data.data
}

export const cancelBooking = async (bookingId: number): Promise<void> => {
    await apiClient.delete(`/bookings/${bookingId}`)
}

export const updateBooking = async (id: number, request: UpdateBookingRequest): Promise<Booking> => {
    const response = await apiClient.patch(`/bookings/${id}`, request)
    return response.data.data
}

export const checkAvailability = async (
    tableId: number,
    startTime: string,
    durationMinutes: number
): Promise<CheckAvailabilityResponse> => {
    const response = await apiClient.post('/bookings/check-availability', {
        tableId,
        startTime,
        durationMinutes,
    })
    return response.data.data
}

export const fetchMyBookings = async (): Promise<Booking[]> => {
    const response = await apiClient.get('/users/me/bookings')
    return response.data.data
}

export const fetchMyBookingSettings = async (): Promise<BookingSettings> => {
    const response = await apiClient.get('/users/me/bookings/settings')
    return response.data.data
}

export const createMyBooking = async (booking: CreateUserBookingRequest): Promise<Booking> => {
    const response = await apiClient.post('/users/me/bookings', booking)
    return response.data.data
}

export const cancelMyBooking = async (bookingId: number): Promise<void> => {
    await apiClient.delete(`/users/me/bookings/${bookingId}`)
}

export const confirmPendingBooking = async (
    bookingId: number,
    request: { tableId: number; startTime: string; durationMinutes: number }
): Promise<Booking> => {
    const response = await apiClient.post(`/bookings/${bookingId}/confirm`, request)
    return response.data.data
}

